//angular
import { Component, Input, Output, OnInit, EventEmitter, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
//app animations
import { AppAnimations } from 'src/app/_shared/animations';
//app data
import { BillCycleTypeValues, BillingPeriodAlignmentValues, BillingPeriodValues, BillingTimingValues, ChargeType, collectionOfBillCycleType, collectionOfBillingPeriod, collectionOfBillingPeriodAlignment, collectionOfBillingTiming, collectionOfChargeType, collectionOfEndDateCondition, collectionOfFrequencyUnit, collectionOfMonthDay, collectionOfChargeStartingDateOptions, collectionOfSubscriptionStartingDateOptions, collectionOfUpToPeriodsType, EndDateConditionValues, FrequencyUnitValues, ChargeStartingDateOptions, VisibleState, StatusValues, DateFormatValues, UpToPeriodsTypeValues } from 'src/app/app.data';
//app interfaces
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
import { ValidatorService } from 'src/app/_shared/validators/validator.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { DataSharingService, UtilsService } from 'src/app/_core/services';
import { PermissionManagerService } from 'src/app/_shared/services/permission/permissions.service';

@Component({
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' },
  selector: 'form-charge-schedule',
  templateUrl: './charge-schedule.component.html',
})

export class FormChargeScheduleComponent implements OnInit, AfterViewInit {
  cleaveNumIntegerOptions;
  collectionOfBillCycleType: Array<DropDown> = collectionOfBillCycleType;
  collectionOfBillingPeriod: Array<DropDown> = collectionOfBillingPeriod;
  collectionOfBillingPeriodAlignment: Array<DropDown> = collectionOfBillingPeriodAlignment;
  collectionOfBillingTiming: Array<DropDown> = collectionOfBillingTiming;
  collectionOfChargeType: Array<DropDown> = collectionOfChargeType;
  collectionOfEndDateCondition: Array<DropDown> = collectionOfEndDateCondition;
  collectionOfFrequencyUnit: Array<DropDown> = collectionOfFrequencyUnit;
  collectionOfMonthDay: Array<any> = collectionOfMonthDay;
  collectionOfChargeStartingDateOptions: Array<DropDown> = collectionOfChargeStartingDateOptions;
  collectionOfUpToPeriodsType: Array<DropDown> = collectionOfUpToPeriodsType;
  defaultChargeType: ChargeType = ChargeType.oneTimeCharge;
  form: FormGroup;
  selectedChargeType: ChargeType = this.defaultChargeType;
  selectedBillCycleType: BillCycleTypeValues = BillCycleTypeValues.subscriptionStartDay;
  selectedStartingDateOption: ChargeStartingDateOptions = ChargeStartingDateOptions.immediately;

  statusForBillCycleTypeMonth: boolean = false;
  statusForBillCycleTypeWeek: boolean = false;
  statusForBillCycleTypeYear: boolean = false;
  statusForBillingPeriod: boolean = false;
  statusForEndCondition: boolean = false;
  ratePlanCharge: any;
  isSubscription: boolean = false;
  isEditOnCreatedSubscription: boolean = false;
  // minDate: Date = new Date();
  minStartingDate: Date = new Date();

  @Input() _billCycleTypeValues = BillCycleTypeValues;
  @Input() _chargeType = ChargeType;
  @Input() _chargeStartingDateOptions = ChargeStartingDateOptions;
  @Input() _data: any;
  @Input() _frequencyUnitValues = FrequencyUnitValues;
  @Input() _statusValues = StatusValues;
  @Input() _visibleState = VisibleState;

  @Output() _emitBillCycleType: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitBodyParams: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitChargeType: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitFormErrors: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _fb: FormBuilder,
    private _meta: MetaService,
    private _shareData: DataSharingService,
    private utils: UtilsService,
    private _validatorService: ValidatorService,
    private permissionS: PermissionManagerService
  ) {

    this._shareData.getSettingsVariables().subscribe(([_decimalPlaces, decimalToken, thousandsToken]) => {
      this.cleaveNumIntegerOptions = {
        numeral: true,
        numeralPositiveOnly: true,
        stripLeadingZeroes: false,
        numeralDecimalScale: 0,
        delimiter: thousandsToken,
        numeralDecimalMark: decimalToken
      };
    });

  }

  ngOnInit(): void {
    this.ratePlanCharge = this._data.ratePlanCharge;
    this.setUpForm();
    // created subscription
    if (this._data.isSubscription) {
      this.isSubscription = true;
      // adds the custom option, used in subscriptions
      this.collectionOfChargeStartingDateOptions = collectionOfSubscriptionStartingDateOptions;
      // edit
      if (this._data?.ratePlanCharge?.id) {
        this.isEditOnCreatedSubscription = true;
        this.form.get('chargeType').disable();
        if (this.selectedStartingDateOption !== ChargeStartingDateOptions.subscriptionFreeTrial && this.selectedStartingDateOption !== ChargeStartingDateOptions.schedule && this.ratePlanCharge?.chargedThroughDate) {
          this.selectedStartingDateOption = ChargeStartingDateOptions.custom;
          this.form.get('startingDate').setValue(new Date(this.ratePlanCharge?.chargedThroughDate));
          this.minStartingDate = new Date();
        }
      }
    }
    // new subscription
    if (this._data.isNewSubscription) {
      this.form.get('chargeType').disable();
    }
  }

  ngAfterViewInit() {
    let previousValid = this.form.valid;
    this.form.valueChanges.subscribe(() => {
      if (this.form.valid !== previousValid) {
        this._emitFormErrors.emit(false);
      }
    });
  }

  onChangeDelayType(_event: any) {
    let _value: any = _event.value
    this.form.get('delayType').setValue(_value);
  }

  onChangeBillCycleType(_billCycleType: BillCycleTypeValues) {
    this.selectedBillCycleType = _billCycleType;
    // Find the option to disable or enable for REB-3156
    const alignToSubscriptionStartOption = this.collectionOfBillingPeriodAlignment.find(option =>
      option.value === BillingPeriodAlignmentValues.alignToSubscriptionStart
    );
    if (alignToSubscriptionStartOption) {
      alignToSubscriptionStartOption.status = (_billCycleType !== BillCycleTypeValues.subscriptionStartDay) ? StatusValues.disabled : StatusValues.active;
    }
    this.assertBillCycleTypeIsMonthOfYearControls()
    this.setBillingCycleType(_billCycleType);
  }


  assertBillCycleTypeIsMonthOfYearControls() {
    if (this.selectedBillCycleType === BillCycleTypeValues.specificMonthOfYear) {
      this.form.setControl('monthlyBillCycleYear',new FormControl(this.ratePlanCharge?.monthlyBillCycleYear ? this.ratePlanCharge?.monthlyBillCycleYear.toString() : null, [Validators.required]));
      this.form.setControl('billCycleDay',new FormControl(this.ratePlanCharge?.billCycleDay ? this.ratePlanCharge?.billCycleDay : '1', [Validators.required, this._validatorService.positiveIntegerNumberExcludeZero, this.validateDay()]));
    } else {
      this.form.setControl('monthlyBillCycleYear',new FormControl(this.ratePlanCharge?.monthlyBillCycleYear ? this.ratePlanCharge?.monthlyBillCycleYear.toString() : null));
      this.form.setControl('billCycleDay',new FormControl(this.ratePlanCharge?.billCycleDay ? this.ratePlanCharge?.billCycleDay : 1, [Validators.required, this._validatorService.positiveIntegerNumberExcludeZero]));
    }
  }

  onChangeBillingPeriod(_value: BillingPeriodValues) {
    this.setBillingPeriod(_value);
  }

  onChangeChargeType(_chargeType: ChargeType){
    this.selectedChargeType = _chargeType;
    this._emitChargeType.emit(_chargeType);
  }

  onChangeEndDateCondition(_event: any) {
    let _value: EndDateConditionValues = _event.value;
    this.setEndDateCondition(_value);
  }

  onChangeFrequencyUnit(_event: any) {
    let _value: FrequencyUnitValues = _event.value
    this.setFrequencyUnit(_value);
  }

  onChangeStartingDateOption(_startingDateOption: ChargeStartingDateOptions){
    switch (_startingDateOption) {
      case ChargeStartingDateOptions.immediately:
        if (this.form.get('delayType')) {
          this.form.get('delayType').setValue('');
          this.form.get('delay').setValue('');
        }
        this.form.get('startingDate').setValue('');
        this.selectedStartingDateOption = ChargeStartingDateOptions.immediately;
        break;

      case ChargeStartingDateOptions.schedule:
        if (!this.form.get('delayType')) {
          this.form.addControl('delayType', new FormControl(UpToPeriodsTypeValues.billingPeriods, [Validators.required]))
          this.form.addControl('delay', new FormControl(1, [Validators.required, this._validatorService.positiveIntegerNumberExcludeZero]));
        }
        this.form.get('startingDate').setValue('');
        this.selectedStartingDateOption = ChargeStartingDateOptions.schedule;
        break;

      case ChargeStartingDateOptions.custom:
        if (this.form.get('delayType')) {
          this.form.get('delayType').setValue('');
          this.form.get('delay').setValue('');
        }
        this.selectedStartingDateOption = ChargeStartingDateOptions.custom;
        break;

      case ChargeStartingDateOptions.subscriptionFreeTrial:
        if (!this.form.get('delayType')) {
          this.form.addControl('delayType', new FormControl(UpToPeriodsTypeValues.billingPeriods, [Validators.required]))
          this.form.addControl('delay', new FormControl(1, [Validators.required, this._validatorService.positiveIntegerNumberExcludeZero]));
        }
        this.form.get('startingDate').setValue('');
        this.selectedStartingDateOption = ChargeStartingDateOptions.subscriptionFreeTrial;
        this.form.get('billCycleType').setValue(BillCycleTypeValues.subscriptionFreeTrial);

        break;
    }
  }

  setBodyParams(): void {
    let bodyParams: any = {
      billCycleDay: this.form.get('billCycleDay').value ? parseInt(this.form.get('billCycleDay').value) : 1,
      billCycleType: this.form.get('billCycleType').value,
      billingPeriod: this.form.get('billingPeriod').value,
      billingPeriodAlignment: this.form.get('billingPeriodAlignment').value,
      billingTiming: this.form.get('billingTiming').value,
      chargeType: this.form.get('chargeType').value,
      endDateCondition: this.form.get('endDateCondition').value,
      specificBillingPeriod: this.utils.convertToNumber(this.form.get('specificBillingPeriod').value),
      weeklyBillCycleDay: this.form.get('weeklyBillCycleDay').value,
      delayType: null,
      delay: null
    };

    if (this.selectedBillCycleType === BillCycleTypeValues.specificMonthOfYear) {
     bodyParams.monthlyBillCycleYear = this.form.get('monthlyBillCycleYear') && this.form.get('monthlyBillCycleYear').value ? parseInt(this.form.get('monthlyBillCycleYear').value) : null
    } else {
      bodyParams.monthlyBillCycleYear = null
    }

      switch (this.selectedStartingDateOption) {
      case ChargeStartingDateOptions.immediately:
        if (this.form.get('delayType')) {
          this.form.removeControl('delayType');
          this.form.removeControl('delay');
        }
        break;

      case ChargeStartingDateOptions.schedule:
        bodyParams.delayType = this.form.get('delayType').value;
        bodyParams.delay = this.utils.convertToNumber(this.form.get('delay').value);
        break;

      case ChargeStartingDateOptions.custom:
        if (this.form.get('delayType')) {
          this.form.removeControl('delayType');
          this.form.removeControl('delay');
        }
        const startingDate = this.form.get('startingDate').value;
        bodyParams.startingDate = startingDate && typeof startingDate !== 'string' ? this._meta.setDateFormat(startingDate, DateFormatValues.YYYY_MM_DD) : startingDate;
        break;

      case ChargeStartingDateOptions.subscriptionFreeTrial:
      bodyParams.delayType = this.form.get('delayType').value;
      bodyParams.delay = this.utils.convertToNumber(this.form.get('delay').value);
      break;
  }

    if (this.statusForEndCondition) {
      bodyParams.upToPeriods = this.utils.convertToNumber(this.form.get('upToPeriods').value);
      bodyParams.upToPeriodsType = this.form.get('upToPeriodsType').value;
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      this._emitFormErrors.emit(true);
      return;
    }

    this._emitBodyParams.emit(bodyParams);
  }

  setBillingCycleType(_value: BillCycleTypeValues) {
    this.statusForBillCycleTypeMonth = _value === BillCycleTypeValues.specificDayOfMonth;
    this.statusForBillCycleTypeWeek = _value === BillCycleTypeValues.specificDayOfWeek;
    this.statusForBillCycleTypeYear = _value === BillCycleTypeValues.specificDayOfYear;
    this._emitBillCycleType.emit(_value);
  }

  setBillingPeriod(_value: BillingPeriodValues) {
    switch (_value) {
      case BillingPeriodValues.week:
        this.form.get('billingPeriod').setValue(FrequencyUnitValues.week);
        this.form.get('billCycleDay').setValue(1);
        this.statusForBillingPeriod = false;
        break;
      case BillingPeriodValues.month:
        this.form.get('billingPeriod').setValue(FrequencyUnitValues.month);
        this.form.get('billCycleDay').setValue(1);
        this.statusForBillingPeriod = false;
        break;
      case BillingPeriodValues.quarter:
        this.form.get('billingPeriod').setValue(FrequencyUnitValues.month);
        this.form.get('billCycleDay').setValue(3);
        this.statusForBillingPeriod = false;
        break;
      case BillingPeriodValues.semiAnnual:
        this.form.get('billingPeriod').setValue(FrequencyUnitValues.month);
        this.form.get('billCycleDay').setValue(6);
        this.statusForBillingPeriod = false;
        break;
      case BillingPeriodValues.annual:
        this.form.get('billingPeriod').setValue(FrequencyUnitValues.year);
        this.form.get('billCycleDay').setValue(1);
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0], collectionOfBillCycleType[4]);
        this.statusForBillingPeriod = false;
        break;
      case BillingPeriodValues.custom:
        this.statusForBillingPeriod = true;
        this.form.get('billingPeriod').setValue(FrequencyUnitValues.month);
        this.form.get('billCycleDay').setValue(1);
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0], collectionOfBillCycleType[1], collectionOfBillCycleType[3], collectionOfBillCycleType[4]);
        break;
    }
  }

  setEndDateCondition(_value: EndDateConditionValues) {
    if (_value === EndDateConditionValues.fixedPeriod) {
      this.statusForEndCondition = true;
      if (!this.form.get('upToPeriodsType')) {
        this.form.addControl('upToPeriodsType',new FormControl(this.ratePlanCharge?.upToPeriodsType ? this.ratePlanCharge?.upToPeriodsType : UpToPeriodsTypeValues.billingPeriods, [Validators.required]));
        this.form.addControl('upToPeriods',new FormControl(this.ratePlanCharge?.upToPeriods ? this.ratePlanCharge?.upToPeriods : 1, [Validators.required, this._validatorService.positiveDecimalNumberExcludeZero]));
      }
    } else {
      this.statusForEndCondition = false;
      if (this.form.get('upToPeriodsType')) {
        this.form.removeControl('upToPeriodsType');
        this.form.removeControl('upToPeriods');
      }
    }
  }

  setFrequencyUnit(_value: FrequencyUnitValues) {
    switch (_value) {
      case FrequencyUnitValues.day:
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0]);
        this.form.get('billCycleType').setValue(BillCycleTypeValues.subscriptionStartDay);
        this.onChangeBillCycleType(BillCycleTypeValues.subscriptionStartDay);
        break;
      case FrequencyUnitValues.week:
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0], collectionOfBillCycleType[2]);
        this.form.get('billCycleType').setValue(BillCycleTypeValues.subscriptionStartDay);
        this.onChangeBillCycleType(BillCycleTypeValues.subscriptionStartDay);
        break;
      case FrequencyUnitValues.month:
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0], collectionOfBillCycleType[1]);
        this.form.get('billCycleType').setValue(BillCycleTypeValues.subscriptionStartDay);
        this.onChangeBillCycleType(BillCycleTypeValues.subscriptionStartDay);
        break;
      case FrequencyUnitValues.year:
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0], collectionOfBillCycleType[3]);
        this.form.get('billCycleType').setValue(BillCycleTypeValues.subscriptionStartDay);
        this.onChangeBillCycleType(BillCycleTypeValues.subscriptionStartDay);
        break;
    }
  }

  setUpForm() {
    this.form = this._fb.group({
      billCycleDay: [this.ratePlanCharge?.billCycleDay ? this.ratePlanCharge?.billCycleDay : 1, [Validators.required, this._validatorService.positiveIntegerNumberExcludeZero]],
      monthlyBillCycleYear: [this.ratePlanCharge?.monthlyBillCycleYear ? this.ratePlanCharge?.monthlyBillCycleYear.toString() : null],
      billCycleType: [this.ratePlanCharge?.billCycleType ? BillCycleTypeValues[this.ratePlanCharge?.billCycleType] : BillCycleTypeValues.subscriptionStartDay, [Validators.required]],
      billingPeriod: [this.ratePlanCharge?.billingPeriod ? FrequencyUnitValues[this.ratePlanCharge?.billingPeriod] : FrequencyUnitValues.month, [Validators.required]],
      billingPeriodAlignment: [this.ratePlanCharge?.billingPeriodAlignment ? BillingPeriodAlignmentValues[this.ratePlanCharge?.billingPeriodAlignment] : BillingPeriodAlignmentValues.alignToCharge, [Validators.required]],
      billingTiming: [this.ratePlanCharge?.billingTiming ? BillingTimingValues[this.ratePlanCharge?.billingTiming] : BillingTimingValues.inAdvance, [Validators.required]],
      chargeType: [this.ratePlanCharge?.chargeType ? this.ratePlanCharge?.chargeType : this._chargeType.oneTimeCharge, [Validators.required]],
      endDateCondition: [this.ratePlanCharge?.endDateCondition ? EndDateConditionValues [this.ratePlanCharge?.endDateCondition] : EndDateConditionValues.subscriptionEnd, [Validators.required]],
      specificBillingPeriod: [this.ratePlanCharge?.specificBillingPeriod ? this.ratePlanCharge?.specificBillingPeriod : 1, [Validators.required, this._validatorService.positiveDecimalNumberExcludeZero]],
      weeklyBillCycleDay: this.ratePlanCharge?.weeklyBillCycleDay,
      delayType: [this.ratePlanCharge?.delayType ? this.ratePlanCharge?.delayType : UpToPeriodsTypeValues.billingPeriods, [Validators.required]],
      delay: [this.ratePlanCharge?.delay ? this.ratePlanCharge?.delay : 1, [Validators.required, this._validatorService.positiveDecimalNumberExcludeZero]],
      startingDate: this.ratePlanCharge?.startingDate ? this.ratePlanCharge?.startingDate : '',
    });

    this.permissionS.checkInput('view_sub_alignment|enabled|SCOPE_SET_VALUE', this.form, 'billingPeriodAlignment', BillingPeriodAlignmentValues.alignToCharge);
    this.permissionS.checkInput('view_sub_billday|enabled|SCOPE_SET_VALUE', this.form, 'billCycleType', BillCycleTypeValues.subscriptionStartDay);
    this.permissionS.checkInput('view_sub_billtiming|enabled|SCOPE_SET_VALUE', this.form, 'billingTiming', BillingTimingValues.inAdvance);
    this.permissionS.checkInput('view_sub_endcondition|enabled|SCOPE_SET_VALUE', this.form, 'endDateCondition', EndDateConditionValues.subscriptionEnd);
    this.permissionS.checkInput('view_sub_startdate|enabled|SCOPE_SET_VALUE', this.form, 'startingDate', ChargeStartingDateOptions.immediately, ()=>{this.onChangeStartingDateOption(ChargeStartingDateOptions.immediately)});


    if(this.statusForEndCondition) {
      this.form.addControl('upToPeriodsType',new FormControl(this.ratePlanCharge?.upToPeriodsType ? this.ratePlanCharge?.upToPeriodsType : UpToPeriodsTypeValues.billingPeriods, [Validators.required]));
      this.form.addControl('upToPeriods',new FormControl(this.ratePlanCharge?.upToPeriods ? this.ratePlanCharge?.upToPeriods : 1, [Validators.required, this._validatorService.positiveDecimalNumberExcludeZero]));
    }

    switch (this.form.get('billingPeriod').value) {
      case FrequencyUnitValues.day:
      case FrequencyUnitValues.year:
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0], collectionOfBillCycleType[3]);
        break;
      case FrequencyUnitValues.week:
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0], collectionOfBillCycleType[2]);
        break;
      case FrequencyUnitValues.month:
        this.collectionOfBillCycleType = [];
        this.collectionOfBillCycleType.push(collectionOfBillCycleType[0], collectionOfBillCycleType[1]);
        break;
    }

    this.setBillingCycleType(this.form.get('billCycleType').value);
    this.setEndDateCondition(this.form.get('endDateCondition').value);

    this.selectedChargeType = this.form.get('chargeType').value;

    this.selectedBillCycleType = this.form.get('billCycleType').value;

    if (this.ratePlanCharge?.delayType && this.ratePlanCharge?.delay) {
      if(this.ratePlanCharge?.billCycleType === BillCycleTypeValues.subscriptionStartDay) {
      this.selectedStartingDateOption = ChargeStartingDateOptions.schedule;
      }
      if(this.ratePlanCharge?.billCycleType === BillCycleTypeValues.subscriptionFreeTrial) {
        this.selectedStartingDateOption = ChargeStartingDateOptions.subscriptionFreeTrial;
      }
    }

    this.assertBillCycleTypeIsMonthOfYearControls()

    //Emit ChargeType
    this._emitChargeType.emit(this.selectedChargeType);
  }

  validateDay() {
    return (control: FormControl) => {
      const monthControl = this.form.get('monthlyBillCycleYear');
      if (monthControl) {
        return this.utils.dayValidator(monthControl)(control);
      }
      return null;
    };
  }
}
